<template>
  <div id="Loader" class="Page Loader">
    <div class="Page_wrapper">
      <img src="/assets/images/bateau.svg" alt="Bateau" />
      <transition name="title" appear>
        <h2>Chargement</h2>
      </transition>
      <!-- <transition name="fade" appear mode="out-in">
        <p ref="content" :key="text" v-html="text"></p>
      </transition> -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import page from "@/mixins/page"

export default {
  components: {  },
  mixins: [ page ],
  data () {
    return {
      loadCount: 0,
      files: [],
      sceneIsOk: false,
      text: null,
      interval: null
    }
  },
  watch: {
    filesIsOk()
    {
      // console.log(this.loadCount, this.files.length, this.sceneIsOk)
      if(this.filesIsOk && this.sceneIsOk)
      {
        this.loadingComplete()
      }
    },
    sceneIsOk()
    {
      // console.log(this.loadCount, this.files.length, this.sceneIsOk)
      if(this.filesIsOk && this.sceneIsOk)
      {
        this.loadingComplete()
      }
    }
  },
  methods: {
    loadingComplete()
    {
      console.log('loadComplete 100%')
      
      setTimeout( () => {
        this.$emit('loadComplete', this.files)
        this.$router.push({ name: 'home' })
      }, 500)
      
    },
    sceneIsLoaded()
    {
      this.sceneIsOk = true
    },
    load()
    {
      var preloader = require('preloader');
      var loader = preloader({
        xhrImages: false
      });

      loader.on('complete', () => {
        this.filesIsOk = true
      } );

      loader.add('./assets/images/ancre.svg')
      loader.add('./assets/images/background.svg')
      loader.add('./assets/images/bateau.svg')
      loader.add('./assets/images/cartes.svg')
      loader.add('./assets/images/carte.svg')
      loader.add('./assets/images/compass-arrow.svg')
      loader.add('./assets/images/compass.svg')
      loader.add('./assets/images/dead.svg')
      loader.add('./assets/images/gouvernail.svg')
      loader.add('./assets/images/lensflare0.png')
      loader.add('./assets/images/lensflare3.png')
      loader.add('./assets/images/mask.png')
      loader.add('./assets/images/pattern-pictos.png')
      loader.add('./assets/images/longuevue.svg')
      loader.add('./assets/images/pirate.svg')
      loader.add('./assets/images/sardine.svg')
      loader.add('./assets/images/shape-small.svg')
      loader.add('./assets/images/shape.svg')
      loader.add('./assets/images/zoom.jpg')
      loader.add('./assets/images/zoom-mobile.jpg')
      loader.add('./assets/sounds/global.mp3')
      loader.add('./assets/sounds/close.mp3')
      loader.add('./assets/sounds/open.mp3')
      loader.add('./assets/sounds/openP.mp3')
      loader.add('./assets/sounds/pError.wav')
      loader.add('./assets/sounds/number.wav')
      loader.add('./assets/sounds/pGood.mp3')
      loader.add('./assets/sounds/pirate.mp3')
      loader.add('./assets/sounds/push.mp3')
      loader.add('./assets/sounds/win.mp3')
      loader.add('./assets/sounds/zoom.mp3')

      loader.load()
    },
    loaded()
    {
      this.loadCount = this.loadCount + 1
    }
  },
  beforeDestroy()
  {
    clearInterval( this.interval )
  },
  created () {
    
  },
  mounted () {
    setTimeout( () => { this.load() }, 1000 );

    // const content = [  
    //   "larguer les amarres",
    //   "lever l'ancre",
    //   "hisser les voiles",
    //   "bon vent",
    // ]

    // this.text = content[0]

    // let i = 0

    // this.interval = setInterval( () => {
    //   console.log(i, content[i])
    //   this.text = content[i]

    //   i++
    //   if(i >= content.length - 1)
    //     i = 0
    // }, 2000)
  }
}
</script>

<style lang="stylus" scoped>

.Loader

  h2

    margin-bottom 0px

  .Page_wrapper

    max-width 860px
    width 70%
    text-align center

  img

    animation boat 1.5s linear infinite alternate-reverse
    position relative

  @keyframes boat

    0%

      transform rotate(5deg)

    50%

      transform rotate(0deg)

    100%

      transform rotate(-5deg)

</style>
